export default __webpack_public_path__ + "static/media/WinItBingo.642306b7.png";